/* Localized DPD Pickup cart widget labels and country names. */
(() => {
  const translations = {
    sk: {"label":"Vyberte krajinu doručenia:","placeholder":"Vyberte krajinu *","button":"Vyberte odberné miesto DPD Pickup","info":"Ak chcete zvoliť iný spôsob doručenia než na odberné miesto DPD Pickup, tento krok preskočte a pri dokončení objednávky vyberte preferovaný spôsob doručenia.","countries":{"AT":"Rakúsko","BE":"Belgicko","BG":"Bulharsko","HR":"Chorvátsko","CZ":"Česko","DK":"Dánsko","EE":"Estónsko","FI":"Fínsko","FR":"Francúzsko","GR":"Grécko","ES":"Španielsko","NL":"Holandsko","IE":"Írsko","LT":"Litva","LV":"Lotyšsko","LU":"Luxembursko","DE":"Nemecko","PL":"Poľsko","PT":"Portugalsko","RO":"Rumunsko","SK":"Slovensko","SI":"Slovinsko","SE":"Švédsko","HU":"Maďarsko","IT":"Taliansko"}},
    pl: {
      label: 'Wybierz kraj wysyłki:',
      placeholder: 'Wybierz kraj *',
      button: 'Wybierz punkt DPD Pickup',
      info: 'Jeżeli chcesz wybrać inny sposób dostawy niż do punktu DPD Pickup, pomiń ten krok i wybierz preferowaną metodę wysyłki na stronie finalizacji zamówienia.',
      countries: { AT: 'Austria', BE: 'Belgia', BG: 'Bułgaria', HR: 'Chorwacja', CZ: 'Czechy', DK: 'Dania', EE: 'Estonia', FI: 'Finlandia', FR: 'Francja', GR: 'Grecja', ES: 'Hiszpania', NL: 'Holandia', IE: 'Irlandia', LT: 'Litwa', LV: 'Łotwa', LU: 'Luksemburg', DE: 'Niemcy', PL: 'Polska', PT: 'Portugalia', RO: 'Rumunia', SK: 'Słowacja', SI: 'Słowenia', SE: 'Szwecja', HU: 'Węgry', IT: 'Włochy' }
    },
    en: {
      label: 'Choose your delivery country:',
      placeholder: 'Choose country *',
      button: 'Choose a DPD Pickup point',
      info: 'If you prefer a delivery method other than a DPD Pickup point, skip this step and choose your preferred delivery method during checkout.',
      countries: { AT: 'Austria', BE: 'Belgium', BG: 'Bulgaria', HR: 'Croatia', CZ: 'Czech Republic', DK: 'Denmark', EE: 'Estonia', FI: 'Finland', FR: 'France', GR: 'Greece', ES: 'Spain', NL: 'Netherlands', IE: 'Ireland', LT: 'Lithuania', LV: 'Latvia', LU: 'Luxembourg', DE: 'Germany', PL: 'Poland', PT: 'Portugal', RO: 'Romania', SK: 'Slovakia', SI: 'Slovenia', SE: 'Sweden', HU: 'Hungary', IT: 'Italy' }
    },
    fr: {
      label: 'Choisissez le pays de livraison :',
      placeholder: 'Choisissez un pays *',
      button: 'Choisir un point relais DPD Pickup',
      info: 'Si vous souhaitez choisir un autre mode de livraison que le point relais DPD Pickup, ignorez cette étape et sélectionnez votre mode de livraison préféré lors du paiement.',
      countries: { AT: 'Autriche', BE: 'Belgique', BG: 'Bulgarie', HR: 'Croatie', CZ: 'République tchèque', DK: 'Danemark', EE: 'Estonie', FI: 'Finlande', FR: 'France', GR: 'Grèce', ES: 'Espagne', NL: 'Pays-Bas', IE: 'Irlande', LT: 'Lituanie', LV: 'Lettonie', LU: 'Luxembourg', DE: 'Allemagne', PL: 'Pologne', PT: 'Portugal', RO: 'Roumanie', SK: 'Slovaquie', SI: 'Slovénie', SE: 'Suède', HU: 'Hongrie', IT: 'Italie' }
    },
    cs: {
      label: 'Vyberte zemi doručení:',
      placeholder: 'Vyberte zemi *',
      button: 'Vyberte výdejní místo DPD Pickup',
      info: 'Pokud chcete zvolit jiný způsob doručení než výdejní místo DPD Pickup, tento krok přeskočte a při dokončení objednávky vyberte preferovaný způsob doručení.',
      countries: { AT: 'Rakousko', BE: 'Belgie', BG: 'Bulharsko', HR: 'Chorvatsko', CZ: 'Česko', DK: 'Dánsko', EE: 'Estonsko', FI: 'Finsko', FR: 'Francie', GR: 'Řecko', ES: 'Španělsko', NL: 'Nizozemsko', IE: 'Irsko', LT: 'Litva', LV: 'Lotyšsko', LU: 'Lucembursko', DE: 'Německo', PL: 'Polsko', PT: 'Portugalsko', RO: 'Rumunsko', SK: 'Slovensko', SI: 'Slovinsko', SE: 'Švédsko', HU: 'Maďarsko', IT: 'Itálie' }
    },
    de: {
      label: 'Wählen Sie Ihr Lieferland:',
      placeholder: 'Land auswählen *',
      button: 'DPD Pickup-Abholpunkt auswählen',
      info: 'Wenn Sie eine andere Versandart als einen DPD Pickup-Abholpunkt wählen möchten, überspringen Sie diesen Schritt und wählen Sie Ihre bevorzugte Versandart beim Checkout.',
      countries: { AT: 'Österreich', BE: 'Belgien', BG: 'Bulgarien', HR: 'Kroatien', CZ: 'Tschechien', DK: 'Dänemark', EE: 'Estland', FI: 'Finnland', FR: 'Frankreich', GR: 'Griechenland', ES: 'Spanien', NL: 'Niederlande', IE: 'Irland', LT: 'Litauen', LV: 'Lettland', LU: 'Luxemburg', DE: 'Deutschland', PL: 'Polen', PT: 'Portugal', RO: 'Rumänien', SK: 'Slowakei', SI: 'Slowenien', SE: 'Schweden', HU: 'Ungarn', IT: 'Italien' }
    },
    es: {
      label: 'Elige el país de envío:',
      placeholder: 'Elige un país *',
      button: 'Elige un punto DPD Pickup',
      info: 'Si prefieres otro método de envío distinto de un punto DPD Pickup, omite este paso y elige el método de envío que prefieras durante el pago.',
      countries: { AT: 'Austria', BE: 'Bélgica', BG: 'Bulgaria', HR: 'Croacia', CZ: 'Chequia', DK: 'Dinamarca', EE: 'Estonia', FI: 'Finlandia', FR: 'Francia', GR: 'Grecia', ES: 'España', NL: 'Países Bajos', IE: 'Irlanda', LT: 'Lituania', LV: 'Letonia', LU: 'Luxemburgo', DE: 'Alemania', PL: 'Polonia', PT: 'Portugal', RO: 'Rumanía', SK: 'Eslovaquia', SI: 'Eslovenia', SE: 'Suecia', HU: 'Hungría', IT: 'Italia' }
    }
  };

  const language = (window.Shopify && window.Shopify.locale ? window.Shopify.locale : document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  const copy = translations[language] || translations.en;

  const applyLocalization = (widget) => {
    if (!widget) return;

    if (widget.dataset.countrySelectorText !== copy.label) widget.dataset.countrySelectorText = copy.label;
    if (widget.dataset.messageOpeningButton !== copy.button) widget.dataset.messageOpeningButton = copy.button;
    if (widget.dataset.additionalInfoText !== copy.info) widget.dataset.additionalInfoText = copy.info;

    Object.entries(copy.countries).forEach(([code, name]) => {
      const key = `countryName${code.charAt(0)}${code.slice(1).toLowerCase()}`;
      if (widget.dataset[key] !== name) widget.dataset[key] = name;
    });

    const label = widget.querySelector('.pp-country-selector-label');
    if (label && label.textContent !== copy.label) label.textContent = copy.label;

    const select = widget.querySelector('.pp-country-selector select');
    if (select) {
      Array.from(select.options).forEach((option) => {
        const text = !option.value ? copy.placeholder : copy.countries[option.value];
        if (text && option.textContent !== text) option.textContent = text;
      });
    }

    const button = widget.querySelector('.oct-choose-point-button');
    if (button && button.textContent !== copy.button) button.textContent = copy.button;

    const info = widget.querySelector('.pp-additional-info');
    if (info && info.textContent !== copy.info) info.textContent = copy.info;

    widget.dataset.dpdLocaleApplied = language;
  };

  const applyAll = () => document.querySelectorAll('.js--map-cart-widget').forEach(applyLocalization);

  document.addEventListener('DOMContentLoaded', () => {
    applyAll();
    new MutationObserver(applyAll).observe(document.body, { childList: true, subtree: true });
  });
})();
